import React from 'react';
import classNames from 'classnames/bind';
import styles from './Flow.css';
var cx = classNames.bind(styles);
export var Flow = function Flow() {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('dot', 'dot1')
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('dot', 'dot2')
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('dot', 'dot3')
  }));
};